export default __webpack_public_path__ + "static/media/dog5.3df50a3d.JPG";